import Draft from 'draft-js';
import { findBrandColor } from 'modules/BrandDefinition';
import * as Constants from 'const';
import * as Models from 'models';
import * as editorUtils from 'utils/editor';

export function getBulletColor<T extends boolean | undefined>(
  isEnabled: T,
  editorState: Draft.EditorState,
  colors: T extends true ? Models.BrandColorsList : unknown,
): T extends true ? Models.BrandColorMap | undefined : undefined {
  if (!isEnabled) {
    return undefined;
  }

  const legacyHEX = editorUtils.getStyleToDisplay(editorState, Constants.StylePrefix.BULLET_COLOR_LEGACY) || '';
  const HEX = editorUtils.getStyleToDisplay(editorState, Constants.StylePrefix.BULLET_COLOR)
    || legacyHEX.replace(/^hex/, '') // for already converted colors we need to cut hex from the color itself just in case
    || '';
  const tint = editorUtils.getStyleToDisplay(editorState, Constants.StylePrefix.BULLET_COLOR_TINT);
  const name = editorUtils.getStyleToDisplay(editorState, Constants.StylePrefix.BULLET_COLOR_NAME);
  const bulletColor = findBrandColor(
    colors as Models.BrandColorsList,
    { name, HEX, tint: tint ? parseInt(tint, 10) : 0 },
  );

  return bulletColor as T extends true ? Models.BrandColorMap | undefined : undefined;
}
